export const industryData = [
  {
    key: "1",
    title: "Retail Industry",
    createdAt: "25 Sep 2023, 01:22 pm",
    status: "Active",
  },
  {
    key: "2",
    title: "Banking",
    createdAt: "29 Sep 2023, 10:20 pm",
    status: "Active",
  },
  {
    key: "3",
    title: "Hotels",
    createdAt: "04 Oct 2023, 08:30 am",
    status: "Active",
  },
  {
    key: "4",
    title: "Financial Services",
    createdAt: "17 Oct 2023, 11:45 am",
    status: "Inactive",
  },
  {
    key: "5",
    title: "Insurance",
    createdAt: "26 Oct 2023, 04:10 pm",
    status: "Inactive",
  },
  {
    key: "6",
    title: "Consulting",
    createdAt: "08 Nov 2023, 05:23 am",
    status: "Inactive",
  },
  {
    key: "7",
    title: "Agriculture",
    createdAt: "11 Nov 2023, 02:32 pm",
    status: "Inactive",
  },
];
